import { render } from "./footerNavigation.vue?vue&type=template&id=facef8ea"
import script from "./footerNavigation.vue?vue&type=script&lang=js"
export * from "./footerNavigation.vue?vue&type=script&lang=js"

import "./footerNavigation.vue?vue&type=style&index=0&id=facef8ea&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__